(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('temp-customer', {
            parent: 'entity',
            url: '/temp-customer?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempCustomer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer/temp-customers.html',
                    controller: 'TempCustomerController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomer');
                    $translatePartialLoader.addPart('dayTimeEnum');
                    $translatePartialLoader.addPart('status');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('temp-customer-detail', {
            parent: 'entity',
            url: '/temp-customer/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.tempCustomer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/temp-customer/temp-customer-detail.html',
                    controller: 'TempCustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tempCustomer');
                    $translatePartialLoader.addPart('dayTimeEnum');
                    $translatePartialLoader.addPart('status');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TempCustomer', function($stateParams, TempCustomer) {
                    return TempCustomer.get({id : $stateParams.id});
                }]
            }
        })
        .state('temp-customer.new', {
            parent: 'temp-customer',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer/temp-customer-dialog.html',
                    controller: 'TempCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                fatherName: null,
                                cellPhone: null,
                                phone: null,
                                isMale: null,
                                email: null,
                                notes: null,
                                saw: null,
                                isActive: null,
                                dayTime: null,
                                status: null,
                                issuedDate: null,
                                issuedBy: null,
                                lCode: null,
                                vatNumber: null,
                                etaaNumber: null,
                                amka: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('temp-customer', null, { reload: true });
                }, function() {
                    $state.go('temp-customer');
                });
            }]
        })
        .state('temp-customer.edit', {
            parent: 'temp-customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer/temp-customer-dialog.html',
                    controller: 'TempCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TempCustomer', function(TempCustomer) {
                            return TempCustomer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('temp-customer.delete', {
            parent: 'temp-customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/temp-customer/temp-customer-delete-dialog.html',
                    controller: 'TempCustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TempCustomer', function(TempCustomer) {
                            return TempCustomer.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('temp-customer', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
